.selectContainer {
    max-width: 200px;
}

.filterContainer {
    display: flex;
    justify-content: flex-end;
    gap: 40px;
    padding-bottom: 20px;
}
